module.exports = __webpack_public_path__ + "img/VALENTINE'S DAY.a3a0d41.svg";